// Get privileges details from local storage
const getPrivilegesDetails = () =>
  JSON.parse(localStorage.getItem("privileges_details") || "[]");


// Check if a specific privilege exists in"Master Settings" -> Locations
export const hasPrivilege = (moduleName, subModuleName, privilegeName) =>
  getPrivilegesDetails().some(
    (item) =>
      item.module_name === moduleName &&
      item.submodules?.[subModuleName]?.privileges?.some(
        (priv) => priv.name === privilegeName
      )
  );
